import React from 'react';
import { Chatbot } from 'react-chatbot-kit';
import { useGlobalization } from '../../contexts';
import { useSelectChatbot } from '../../selectors';
import ActionProvider from './ActionProvider';
import MessageParser from './MessageParser';
const ChatbotWithSession = ({ config }) => {
    const { t } = useGlobalization();
    const { sessionId } = useSelectChatbot();
    const loadMessages = () => {
        const chatMessages = localStorage.getItem('chatMessages');
        const loadedMessage = chatMessages === null
            ? undefined
            : JSON.parse(chatMessages).filter((m) => 
            // discard empty answers while loading chat history
            !(m.message === '' &&
                m?.widget === 'chatbotAnswer'));
        return loadedMessage;
    };
    if (!sessionId) {
        return null;
    }
    return (React.createElement(Chatbot, { config: config, messageParser: MessageParser, validator: input => !!input.trim(), actionProvider: ActionProvider, placeholderText: t('Type a message...'), messageHistory: loadMessages() }));
};
export default ChatbotWithSession;
